import { getBackgroundCheckConfigEnabledType } from '@/backend/features/background-check/utils/getBackgroundCheckConfigEnabledType';
import { AppContext } from '@juvare/platform-app/App';
import { AppState } from '@juvare/platform-sdk-react/types';
import { createHistory } from '../../../background-tasks';
import { isManualBackgroundCheck as isManualBackgroundCheckFn } from '../../../shared/inManualBackgroundCheck';
import { BackgroundCheckStatus, BackgroundCheckType } from '../../../types';
import { isBackgroundCheckConsentGiven, isBackgroundCheckFormComplete } from '../../../utils';
import {
    BackgroundCheckHistoryColumns,
    BackgroundCheckHistoryData,
    backgroundCheckHistoryEntityName,
} from '../../background-check-history-data';
import { BackgroundCheckData } from '../types';

export function recalculateBackgroundCheckStatus(
    context: AppContext<AppState>,
    account: {
        data: BackgroundCheckData;
        id: string;
    },
) {
    const config = context.appState.settings.backgroundCheckConfig;
    const historyStorage = context.storage<BackgroundCheckHistoryData, BackgroundCheckHistoryColumns>(backgroundCheckHistoryEntityName);
    let primaryBackgroundCheckType: BackgroundCheckType | undefined = account.data.primaryBackgroundCheckType;
    let backgroundCheckStatus: BackgroundCheckStatus = 'readyToSubmit';
    let backgroundCheck: BackgroundCheckData['backgroundCheck'] = account.data.backgroundCheck;

    const backgroundCheckConfigType = getBackgroundCheckConfigEnabledType(context);

    const isManualBackgroundCheck = isManualBackgroundCheckFn(backgroundCheckConfigType, primaryBackgroundCheckType);

    if (!isBackgroundCheckConsentGiven(account.data) && !isManualBackgroundCheck) {
        backgroundCheckStatus = 'didNotConsent';
    } else if (!isBackgroundCheckFormComplete(account.data)) {
        backgroundCheckStatus = isManualBackgroundCheck ? 'readyToSubmit' : 'formIncomplete';
    }

    Object.entries(config.type).forEach(([type, config]) => {
        if (!config.enabled) {
            return;
        }

        if (!primaryBackgroundCheckType) {
            primaryBackgroundCheckType = type as BackgroundCheckType;
        }

        backgroundCheck = {
            ...backgroundCheck,
            [type as BackgroundCheckType]: {
                status: backgroundCheckStatus,
                updatedAt: Date.now(),
            },
        };

        if (backgroundCheckStatus !== account.data.primaryBackgroundCheckStatus) {
            createHistory({
                historyStorage,
                accountData: account.data,
                nextStatus: backgroundCheckStatus,
                accountId: account.id,
                type: type as BackgroundCheckType,
                internalStatusChange: true,
            });
        }
    });

    return {
        backgroundCheck,
        primaryBackgroundCheckType,
        primaryBackgroundCheckStatus: backgroundCheckStatus,
        primaryBackgroundUpdatedAt: Date.now(),
    };
}
